'use client'

import SearchForm from '@/src/components/common/home/flightSearch/searchForm'
import AirlineDetailWrapper from '@/src/components/pages/airlineDetail'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { VARIANT } from '@/src/utils/buildUtils'
import { featureConfig } from '@/src/utils/featureConfig'
import { Box, Container, useTheme, useMediaQuery } from '@mui/material'
import type { AirlinePage } from '@/src/types/airlineDetail'

interface AirlineDetailPageContainerProps {
    locale: string
    airlineSlug: string
    airlineData: AirlinePage
    serverRecentSearches: RecentSearchListItem[]
    isMobile: boolean
    domainCountry?: string
}

export default function AirlineDetailPageContainer({
    locale,
    airlineSlug,
    airlineData,
    serverRecentSearches,
    isMobile,
    domainCountry
}: AirlineDetailPageContainerProps) {
    const { MULTI_CITY } = featureConfig[VARIANT]
    const hideMulticity = !MULTI_CITY

    return (
        <>
            {/* Search Form */}
            <Container
                sx={{
                    border: 1,
                    borderColor: 'grey.100',
                    backgroundColor: 'common.white',
                    px: { xs: 2, md: 4 },
                    py: 2,
                    borderRadius: 2,
                    my: 2
                }}
                maxWidth="xl"
            >
                <SearchForm isMobile={isMobile} serverRecentSearches={serverRecentSearches} hideMulticity={hideMulticity} />
            </Container>

            {/* Main Content */}
            <Box component="main" sx={{ flex: 1, bgcolor: 'grey.50' }}>
                <AirlineDetailWrapper airlineData={airlineData} locale={locale} isMobile={isMobile} />
            </Box>
        </>
    )
}

